import React from "react";
import { Link } from "react-router-dom";
import TopBtn from "../Components/TopBtn";
function Footer() {
  const gotoTop = () => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };

  const currentYear = new Date().getFullYear();

  return (
    <>
      <TopBtn />
      <div id="Footer">
        <div className="FooterContainer">
          <div className="FooterLeft">
            <img src="/Images/vbu_logo.png" alt="logo" />
            <h4>University Department of Education</h4>
            <p>Vinoba Bhave University, Hazaribagh</p>
          </div>
          <div className="FooterMiddle">
            <div className="FooterMiddleLeft">
              <ul>
                <Link to="/BA-BEd" onClick={gotoTop}>
                  <li>Integrated B.A./B.Sc-B.Ed</li>
                </Link>
                <Link to="/MEd" onClick={gotoTop}>
                  <li>M.Ed.</li>
                </Link>
                <Link to="/teachingMembers" onClick={gotoTop}>
                  <li>Teaching Staff</li>
                </Link>
                <Link to="/nonTeachingMembers" onClick={gotoTop}>
                  <li>Non Teaching Staff</li>
                </Link>
                {/* <Link to="" onClick={gotoTop}>
                  <li>Facility</li>
                </Link> */}
              </ul>
            </div>
            <div className="FooterMiddleRight">
              <ul>
                <Link to="/allNotice" onClick={gotoTop}>
                  <li>Notice</li>
                </Link>
                <Link to="" onClick={gotoTop}>
                  <li>Events</li>
                </Link>
                <Link to="/library" onClick={gotoTop}>
                  <li>Library</li>
                </Link>
                <Link to="/gallery" onClick={gotoTop}>
                  <li>Gallery</li>
                </Link>
                <Link to="/contact" onClick={gotoTop}>
                  <li>Contact</li>
                </Link>
                <Link to="/about" onClick={gotoTop}>
                  <li>About</li>
                </Link>
              </ul>
            </div>
          </div>
          <div className="FooterRight">
            <div class="mapouter">
              <div class="gmap_canvas">
                <iframe
                  style={{ height: "100%", width: "100%", border: "0" }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="University Department of Education Location"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d227.76483124491764!2d85.37064316322089!3d24.022695717265933!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39f49d9fc96fa0fb%3A0xc6036c169ca57748!2sUniversity%20Department%20of%20Education!5e0!3m2!1sen!2sin!4v1769044660402!5m2!1sen!2sin"
                ></iframe>
              </div>
            </div>
          </div>
        </div>

        <div className="FooterCopyRight">
          <span>
            &copy;&nbsp;CopyRight <span id="data">{currentYear}</span> University Department of Education. All
            Rights Reserved. Design and Developed by &nbsp;
            <Link to="https://techiesgateway.com" target="_blank">
              <b>TechiesGateway</b>
            </Link>
          </span>
        </div>
      </div>
    </>
  );
}

export default Footer;
